function cleanBaseUrl(value) {
  return String(value || '').replace(/\/$/, '');
}

function withTracking(path, trustId, campaign, language = null) {
  const params = new URLSearchParams();
  if (trustId) params.set('trust', trustId);
  if (language) params.set('lang', language);
  if (campaign) params.set('campaign', campaign);
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

export function buildHomeSignpostingUrl(baseUrl, trustId, campaign = 'poster_generic') {
  return `${cleanBaseUrl(baseUrl)}${withTracking('/Home', trustId, campaign)}`;
}

export function buildJourneySignpostingUrl(baseUrl, trustId, journeyId, campaign = 'studio_journey_link', language = null) {
  // Optional language uses the patient app's existing ?lang= QR bootstrap.
  // Unspecified languages preserve the existing Signposting Tools behaviour.
  if (!journeyId) return `${cleanBaseUrl(baseUrl)}${withTracking('/Home', trustId, campaign, language)}`;
  return `${cleanBaseUrl(baseUrl)}${withTracking(`/journeys/${encodeURIComponent(journeyId)}`, trustId, campaign, language)}`;
}

export function buildPosterTargetUrl(baseUrl, trustId, template) {
  if (!template || template.targetType === 'home') {
    return buildHomeSignpostingUrl(baseUrl, trustId, template?.campaign || 'poster_generic');
  }
  return buildJourneySignpostingUrl(baseUrl, trustId, template.journeyId, template.campaign || `poster_${template.id || 'journey'}`);
}
